import AdSense from "react-adsense"
import React from "react"

const Adsense = () => (
  <AdSense.Google
    client="ca-pub-6511226142017261"
    slot="9942905255"
    style={{ display: "block", marginBottom: "36px" }}
    format="fluid"
    responsive="true"
    layoutKey="-gw-1+2a-9x+5c"
  />
)

export default Adsense
